export function category(state) {
  return state.category;
}
